<template>
  <div
    ref="containerRef"
  >

    <AttachFiles
      :attachments="props.attachments"
      :accept="props.accept"
      :max-files="props.maxFiles"
      :description="props.description"
      :show-file-library="props.showFileLibrary"
      @update:attachments="updateAttachments"
      @show-file-library="openFileLibrary"
    />

    <Component
      v-if="shouldLoadFileLibrary"
      v-model:open="showLibraryModal"
      :is="libraryModal"
      :accept="props.accept"
      :max-files="props.maxFiles === 1 ? 1 : props.maxFiles - props.attachments.length"
      :description="props.description"
      @add-attachments="addAttachments"
    />

  </div>
</template>

<script setup>
import AttachFiles from "./AttachFiles.vue";
import {FILE_ATTACHMENT_PROPS} from "../constants/FileLibrary.js";
import {defineAsyncComponent, onBeforeUnmount, onMounted, ref} from "vue";

const emits = defineEmits(["update:attachments"]);
const props = defineProps({...FILE_ATTACHMENT_PROPS});

const containerRef = ref();
const shouldLoadFileLibrary = ref(false);
const showLibraryModal = ref(false);

const libraryModal = defineAsyncComponent(() => import("./FileLibraryModal.vue"));

const openFileLibrary = () => {
  if (!props.showFileLibrary) return;
  loadFileLibraryComponent();
  showLibraryModal.value = true;
};

const addAttachments = (newAttachments) => {
  if (props.maxFiles === 1) {
    updateAttachments(newAttachments);
    return;
  }

  newAttachments.forEach((attachment, index) => {
    attachment.order = props.attachments.length + index;
  });

  const allAttachments = props.attachments
    .concat(newAttachments);

  updateAttachments(allAttachments);
};

const updateAttachments = (attachments) => {
  emits("update:attachments", attachments.sort((a, b) => a.order - b.order));
  if (showLibraryModal.value) showLibraryModal.value = false;
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    loadFileLibraryComponent();
  });
});

const loadFileLibraryComponent = () => {
  shouldLoadFileLibrary.value = true;
  containerRef.value.removeEventListener("mouseenter", loadFileLibraryComponent);
  observer.disconnect();
};

onMounted(() => {
  if (!containerRef.value) return;
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  if (isMobile) {
    observer.observe(containerRef.value);
  } else {
    containerRef.value.addEventListener("mouseenter", loadFileLibraryComponent);
  }
});

onBeforeUnmount(() => {
  if (containerRef.value) containerRef.value.removeEventListener("mouseenter", loadFileLibraryComponent);
  observer.disconnect();
});
</script>
